<template>
  <div>
    <svg :style="svgStyle" ref="canvas" :height="height" :width="width" @touchstart="handleMouseDown" @touchmove="handleMouseMove" @touchend="handleMouseUp" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp">
      <SvgPath v-for="(element, index) in elements" @click="clickPath(element)" :key="index" :path="element.element" :width="width" :height="height" />
      <SvgPath v-if="currentPath !== null" :path="currentPath" :width="width" :height="height" />
    </svg>
  </div>
</template>

<script>
import SvgPath from './SvgPath'
import { mapActions, mapGetters } from 'vuex'
var erase = require('@/utils/erase')
export default {
  data () {
    return {
      top: 0,
      left: 0,
      isDrawing: false,
      currentPath: null,
      rect: null
    }
  },
  methods: {
    handleMouseDown (e) {
      if (!this.isDrawing && this.$store.getters.canDraw) {
        this.currentPath = Object.assign({}, this.newPath())
      }

      if (this.$store.getters.canDraw) {
        this.isDrawing = true
      }

      if (e.type === 'touchstart') {
        this.rect = e.target.getBoundingClientRect()
      }
    },
    handleMouseMove (e) {
      e.preventDefault()
      if (this.isDrawing) {
        var x, y
        if (e.type === 'touchmove') {
          // var rect = e.target.getBoundingClientRect()
          x = e.touches[0].clientX - this.rect.left
          y = e.touches[0].clientY - this.rect.top
        } else {
          x = e.offsetX
          y = e.offsetY
        }
        this.currentPath.points.push({ x: x / this.width, y: y / this.height })
      }
    },
    handleMouseUp (e) {
      if (this.isDrawing) {
        this.isDrawing = false
        if (this.currentPath.points.length > 1) {
          if (this.tool === 'edit' || this.tool === 'marker') {
            this.addElement({ pageNumber: this.page.pageNumber, type: 'path', element: this.currentPath }).then(_ => {
              setTimeout(() => {
                this.currentPath = null
              }, 100)
            })
          } else if (this.tool === 'eraser') {
            this.elements.forEach(el => {
              var paths = [el.element.points.map(e => { return [Math.trunc(e.x * this.width), Math.trunc(e.y * this.height)] })]
              var delPath = this.currentPath.points.map(e => { return [Math.trunc(e.x * this.width), Math.trunc(e.y * this.height)] })
              var newPath = erase.erase(paths, delPath)
              if (newPath.length > 1 || newPath.length === 0 || newPath[0].length !== paths[0].length) {
                this.deleteElement(el.id)
              }
            })

            this.currentPath = null
          }
          if (e.type === 'touchend') {
            this.rect = null
          }
        }
      }
    },
    clickPath (element) {
      if (this.$store.getters.tool === 'eraser') {
        this.deleteElement(element.id)
      }
    },
    newPath () {
      return {
        color: this.$store.getters.color,
        type: this.$store.getters.tool,
        points: []
      }
    },
    ...mapActions(['addElement', 'deleteElement']),
    test (event) {
      console.log(event)
    }
  },
  computed: {
    elements () {
      return this.$store.getters.elementsByPageNumber(this.page.pageNumber)
    },
    svgStyle () {
      var style = {}
      if (this.$store.getters.drawMode !== 'hide' && this.$store.getters.drawMode !== 'view') {
        style.cursor = 'crosshair'
      }

      return style
    },
    ...mapGetters(['tool', 'canDraw'])
  },
  props: ['page', 'height', 'width'],
  components: {
    SvgPath
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/page/PageDraw.vue